import { render, staticRenderFns } from "./LightGreenSection.vue?vue&type=template&id=338fc936&scoped=true"
import script from "./LightGreenSection.vue?vue&type=script&lang=js"
export * from "./LightGreenSection.vue?vue&type=script&lang=js"
import style0 from "./LightGreenSection.vue?vue&type=style&index=0&id=338fc936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338fc936",
  null
  
)

export default component.exports